// src/campaigns/configs/campaigns.2026.ts

import { buildCampaignsForYear } from "./campaign-factory";

export const campaigns2026 = buildCampaignsForYear(2026);
